import { useQuery } from '@tanstack/react-query';
import { getAuditTrail } from '../services/api/auditTrail';

export function useAuditTrail(subjectType: string, subjectId: number, limit = 20) {
  return useQuery({
    queryKey: ['auditTrail', subjectType, subjectId],
    queryFn: () => getAuditTrail(subjectType, subjectId, { limit }),
    enabled: subjectId > 0,
  });
}
